module.exports = __webpack_public_path__ + "static/img/bottom-button-1.ca1f0dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/bottom-button-1.png
// module id = p1yG
// module chunks = 1